import React from 'react';

import { SOCard, SOListError, SOListSkeleton } from '../../components';
import { ScheduledOrderDetailDialog } from '../ScheduledOrderDetailDialog';

import { useScheduledOrdersList, useScheduledOrdersListLang } from './hooks';

import makeClasses from './ScheduledOrdersList.style';

export function ScheduledOrdersList() {
  const _classes = makeClasses();
  const lang = useScheduledOrdersListLang();
  const {
    isLoading,
    isError,
    refetch,
    orders,
    count,
    selectedOrderId,
    handleCardClick,
    handleDialogClose,
  } = useScheduledOrdersList();

  const renderBody = () => {
    if (isLoading) {
      return <SOListSkeleton />;
    }

    if (isError) {
      return <SOListError onRetry={() => refetch()} />;
    }

    if (count === 0) {
      return (
        <div className={_classes.emptyState}>
          <h3 className={_classes.emptyTitle}>{lang.emptyTitle}</h3>
          <p className={_classes.emptyDescription}>{lang.emptyDescription}</p>
        </div>
      );
    }

    return (
      <ul className={_classes.list}>
        {orders.map(order => (
          <li key={order.orderId} className={_classes.listItem}>
            <SOCard order={order} onClick={handleCardClick} />
          </li>
        ))}
      </ul>
    );
  };

  return (
    <section className={_classes.root}>
      <div className={_classes.panel}>
        <header className={_classes.panelHeader}>
          <h2 className={_classes.panelTitle}>{lang.listTitle}</h2>
          {!!count && <span className={_classes.countBadge}>{count}</span>}
        </header>

        <div className={_classes.panelBody}>{renderBody()}</div>
      </div>

      <ScheduledOrderDetailDialog
        orderId={selectedOrderId}
        onClose={handleDialogClose}
      />
    </section>
  );
}
